import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, tap} from 'rxjs';
import {Notification} from '../models/notification.model';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private http = inject(HttpClient);
  private apiUrl = environment.backend + '/notifications';

  private notificationsSubject = new BehaviorSubject<Notification[]>([]);
  public notifications$ = this.notificationsSubject.asObservable();

  private unreadCountSubject = new BehaviorSubject<number>(0);
  public unreadCount$ = this.unreadCountSubject.asObservable();

  fetchInitialData(): void {
    this.http.get<Notification[]>(this.apiUrl).subscribe(notifications => {
      this.notificationsSubject.next(notifications);
    });

    this.http.get<number>(`${this.apiUrl}/unread-count`).subscribe(count => {
      this.unreadCountSubject.next(count);
    });
  }

  markAsRead(id: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/mark-as-read`, {}).pipe(
      tap(() => this.fetchInitialData())
  );
  }

  // Markiert alle Nachrichten als gelesen
  markAllAsRead(): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/mark-all-as-read`, {}).pipe(
      tap(() => this.fetchInitialData())
  );
  }
}
